// Format initials to uppercase, dot-separated: "tt" -> "T.T.", "J.A." stays "J.A.". Centralised
// from the identical copies in ClientInformationScreen + PersonenAutoScreen.
export function formatInitials(value: string): string {
  if (!value) return '';
  const letters = value.replace(/[^a-zA-Z]/g, '').toUpperCase();
  if (letters.length === 0) return '';
  return letters.split('').join('.') + '.';
}
